import {announce} from '@github-ui/aria-live'
import {useMutation, useQueryClient} from '@github-ui/react-query'

import type {CreateSavedViewResponse, SetSavedViewPinnedVariables} from '../components/views/types'
import {LABELS} from '../constants/labels'
import {
  primeSavedViewCaches,
  type SavedViewMutationOptions,
  sendSavedViewMutationJson,
} from '../utils/saved-view-mutations'

const pinnedErrorLabel = (pinned: boolean) => (pinned ? LABELS.views.pinError : LABELS.views.unpinError)

export function useSetSavedViewPinnedMutation({owner, repo}: SavedViewMutationOptions) {
  const queryClient = useQueryClient()

  // Primes the single-view cache from the pin response, then invalidates the list; announces a direction-aware error.
  return useMutation<CreateSavedViewResponse, Error, SetSavedViewPinnedVariables>({
    mutationFn: ({id, pinned}) =>
      sendSavedViewMutationJson<CreateSavedViewResponse>(
        `/${owner}/${repo}/issues/views/${id}/pinned.json`,
        {method: 'PUT', body: {pinned}},
        pinnedErrorLabel(pinned),
      ),
    onSuccess: ({savedView}) => primeSavedViewCaches({queryClient, owner, repo}, savedView),
    onError: (_error, {pinned}) => announce(pinnedErrorLabel(pinned), {assertive: true}),
  })
}
